import { getDaysInMonth } from '../../helpers/date';

type DayDetailsParams = {
    index: number;
    daysInMonth: number;
    firstDay: number;
    year: number;
    month: number;
};

export function getDayDetails({
    index,
    daysInMonth,
    firstDay,
    year,
    month,
}: DayDetailsParams) {
    const date = index - firstDay;
    let prevMonth = month - 1;
    let prevYear = year;
    if (prevMonth < 0) {
        prevMonth = 11;
        prevYear--;
    }
    const daysInPrevMonth = getDaysInMonth(prevYear, prevMonth);
    const isPrevMonth = date < 0;
    const isNextMonth = date >= daysInMonth;
    const isPrevYear = isPrevMonth && month === 0;
    const isNextYear = isNextMonth && month === 11;
    const _month = isPrevMonth ? prevMonth : isNextMonth ? month + 1 : month;
    const _year = isPrevYear ? prevYear : isNextYear ? year + 1 : year;
    const _date = (isPrevMonth ? daysInPrevMonth + date : date % daysInMonth) + 1;
    return {
        date: _date,
        day: index % 7,
        disabled: date < 0 || date >= daysInMonth,
        jsDate: new Date(_year, _month, _date),
    };
}
